import { Typography } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

import { tokens } from "./tokens";

const useStyles = makeStyles(() => ({
    note: {
        display: "flex",
        gap: "9px",
        alignItems: "flex-start",
        background: tokens.accentSoft,
        border: `1px solid ${tokens.accentLine}`,
        borderRadius: "9px",
        padding: "11px 14px",
        fontSize: "12.5px",
        color: tokens.muted,
        marginTop: "4px",
    },
    icon: {
        width: "15px",
        height: "15px",
        color: tokens.accent,
        flex: "none",
        marginTop: "1px",
    },
}));

export const PermissionNote: React.FC = ({ children }) => {
    const classes = useStyles();

    return (
        <div className={classes.note}>
            <InfoOutlinedIcon className={classes.icon} />
            <Typography component="span" style={{ fontSize: "inherit", color: "inherit" }}>{children}</Typography>
        </div>
    );
};
